import { render, staticRenderFns } from "./CPDueDiligenceDocumentsOverviewSkeletonLoader.vue?vue&type=template&id=38e1eb03&scoped=true&"
import script from "./CPDueDiligenceDocumentsOverviewSkeletonLoader.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceDocumentsOverviewSkeletonLoader.vue?vue&type=script&lang=ts&"
import style0 from "./CPDueDiligenceDocumentsOverviewSkeletonLoader.vue?vue&type=style&index=0&id=38e1eb03&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1eb03",
  null
  
)

export default component.exports